import { Box, Container } from '@mui/material';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import Header from './components/Header';
import JobOffers from './pages/JobOffersPage';
import BenefitsPage from './pages/BenefitsPage';
import PHATtesMiteinanderPage from './pages/PHATtesMiteinanderPage';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PageNotFound from './pages/PageNotFound';
import ApplicationProcess from './pages/ApplicationProcessPage';

const App = (): JSX.Element => (
  <Box
    sx={{
      // phatconsulting.de: slate page, fading to dark blue towards the footer
      background: 'linear-gradient(180deg, #5f7580 0%, #5f7580 65%, #344853 100%)',
      minHeight: '100vh',
    }}
  >
    <BrowserRouter>
      <Header />

      <ScrollToTop />
      <Container maxWidth="lg" style={{ marginTop: 50 }}>
        <Switch>
          <Route path="/" exact>
            <JobOffers />
          </Route>
          {/* Job details and applications moved to onapply; keep old links alive. */}
          <Redirect from="/jobs" to="/" />
          <Redirect from="/application" to="/" />
          <Redirect from="/applicationConfirmation" to="/" />
          <Redirect from="/declarationOfConsent" to="/" />
          <Route path="/applicationProcess">
            <ApplicationProcess />
          </Route>
          <Route path="/PHATtesMiteinander">
            <PHATtesMiteinanderPage />
          </Route>
          <Route path="/Benefits">
            <BenefitsPage />
          </Route>
          <Route path="*">
            <PageNotFound />
          </Route>
        </Switch>
      </Container>

      <Footer />
    </BrowserRouter>
  </Box>
);

export default App;
